import { config } from '../../utils/config'

export async function getReportingRegions(token?: string | null) {
  const url = new URL(`${config.publicRuntimeConfig.humpclubRoot}/reporting/v2/regions`)

  const response = await fetch(url.toString(), {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  })

  if (!response.ok) {
    throw new Error(`Regions request failed (${response.status})`)
  }
  return response.json()
}
